import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Comics from './views/Comics.vue';
import ViewItems from './views/ViewItems.vue';
import Games from './views/Games.vue';
import OtherProjects from './views/OtherProjects.vue';
import Universe from './views/Universe.vue';
import Search from './views/Search.vue';
import CreateItem from './views/CreateItem.vue';
import RecoverPassword from './views/RecoverPassword.vue';
import Goggle from './views/Goggle.vue';
import PageNotFound from './views/PageNotFound.vue';

Vue.use(Router);

const GWTP_TITLE = "GWTP - Neo-realistic absurdism";

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: GWTP_TITLE,
            },
        },
        {
            path: '/comics',
            name: 'comics',
            component: Comics,
            meta: {
                title: 'Comics',
            },
        },
        {
            path: '/items',
            name: 'view-items',
            component: ViewItems,
            meta: {
                title: 'Browse posts',
            },
        },
        {
            path: '/games',
            name: 'games',
            component: Games,
            meta: {
                title: 'Games',
            },
        },
        {
            path: '/other-projects',
            name: 'other projects',
            component: OtherProjects,
            meta: {
                title: 'Other projects',
            },
        },
        {
            path: '/about',
            name: 'about',
            component: Universe,
            meta: {
                title: 'Universe',
            },
        },
        {
            path: '/about/:subject',
            name: 'about-subject',
            component: Universe,
            meta: {
                title: 'Universe',
            },
        },
        {
            path: '/search',
            name: 'search',
            component: Search,
            meta: {
                title: 'Search',
            },
        },
        {
            path: '/create',
            name: 'create',
            component: CreateItem,
            meta: {
                title: 'Create item',
            },
        },
        {
            path: '/recover-password',
            name: 'recover-password',
            component: RecoverPassword,
            meta: {
                title: 'Recover password',
            },
        },
        {
            path: '/goggle',
            name: 'goggle',
            component: Goggle,
            meta: {
                title: 'Goggle',
            },
        },

        // default route
        {
            path: "*",
            component: PageNotFound,
            meta: {
                title: 'Page not found',
            },
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            if (to.hash) {
                return {
                    selector: to.hash,
                    // , offset: { x: 0, y: 10 }
                };
            }
            return { x: 0, y: 0 };
        }
    },

});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find( (r) => r.meta && r.meta.title);

    // If a route with a title was found, set the document (page) title to that value.
    document.title = nearestWithTitle ? `${nearestWithTitle.meta.title} - ${GWTP_TITLE}` : GWTP_TITLE;

    next();
  });
  
export default router;
